/**
 * Yardım (sayfa kullanım talimatı) API çağrıları.
 *
 * Rol İSTEMCİDEN GÖNDERİLMEZ — backend JWT'deki rolü kullanır. Buradaki
 * fonksiyonlarda bilerek `role` parametresi yoktur (admin uçları hariç; orada
 * rol DÜZENLENEN hedefi belirtir, çağıranın yetkisini değil).
 */
import apiClient from "@/api/client";

/** Bu kullanıcının rolü için yardım metni bulunan sayfa id'leri. */
export async function fetchAvailableHelpPages() {
  const { data } = await apiClient.get("/help/available");
  return Array.isArray(data?.page_ids) ? data.page_ids : [];
}

/** Bir sayfanın çözülmüş yardım içeriği. Yoksa 404 fırlatır. */
export async function fetchHelpContent(pageId) {
  const { data } = await apiClient.get(`/help/page/${encodeURIComponent(pageId)}`);
  return data;
}

/* --- admin (yardim.duzenle) --- */

export async function fetchHelpPageList() {
  const { data } = await apiClient.get("/help/admin/pages");
  return data;
}

export async function fetchHelpForEdit(pageId, roleSlug) {
  const { data } = await apiClient.get(
    `/help/admin/page/${encodeURIComponent(pageId)}/${encodeURIComponent(roleSlug)}`
  );
  return data;
}

export async function saveHelpContent(pageId, roleSlug, doc) {
  const { data } = await apiClient.put(
    `/help/admin/page/${encodeURIComponent(pageId)}/${encodeURIComponent(roleSlug)}`,
    doc
  );
  return data;
}

/** "?" butonunu bu sayfa+rol için aç/kapat. Metne dokunmaz. */
export async function setHelpVisibility(pageId, roleSlug, enabled) {
  const { data } = await apiClient.put(
    `/help/admin/page/${encodeURIComponent(pageId)}/${encodeURIComponent(roleSlug)}/visibility`,
    { enabled }
  );
  return data;
}

export async function resetHelpContent(pageId, roleSlug) {
  const { data } = await apiClient.delete(
    `/help/admin/page/${encodeURIComponent(pageId)}/${encodeURIComponent(roleSlug)}`
  );
  return data;
}
